import type { App, Plugin } from 'vue'
import DesignForm from '@/components/design-form/index.vue'
import GenerateForm from '@/components/generate-form/GenerateForm.vue'
import zyForm from '@/components/zy/form.vue'
import MaDictColumn from '@/components/ma-dict/ma-dict-column/index.vue'
import MaDictColumnList from '@/components/ma-dict/ma-dict_column-list/index.vue'
import MaDictLabel from '@/components/ma-dict/ma-dict-label/index.vue'
import MaDictRadio from '@/components/ma-dict/ma-dict-radio/index.vue'
import MaDictTreeSelect from '@/components/ma-dict/ma-dict-tree-select/index.vue'
import MaDictSelect from '@/components/ma-dict/ma-dict-select/index.vue'
import MaDataColumn from '@/components/ma-data/ma-data-column/index.vue'
import MaDataLabel from '@/components/ma-data/ma-data-label/index.vue'
import MaDataSelect from '@/components/ma-data/ma-data-select/index.vue'
import MaDataTreeSelect from '@/components/ma-data/ma-data-tree-select/index.vue'
import MaDataTable from '@/components/ma-data/ma-data-table/index.vue'

import MaIcon from '@/components/ma-icon/index.vue'
import MaEditor from '@/components/ma-editor/index.vue'
import MaMarkdown from '@/components/ma-markdown/index.vue'
import MaMarkdownEditor from '@/components/ma-markdown-editor/index.vue'
import MaMarkdownPreview from '@/components/ma-markdown-preview/index.vue'
import MaAddress from '@/components/ma-address/index.vue'
import MaUserInput from '@/components/ma-user/ma-user-input/index.vue'
import MaUserDialog from '@/components/ma-user/ma-user-dialog/index.vue'
import MaOrgSelect from '@/components/ma-org/ma-org-select/index.vue'
import MaDeviceInput from '@/components/ma-device/ma-device-input/index.vue'
import MaDianjianInput from '@/components/ma-dianjian/ma-dianjian-input/index.vue'
import MaDeviceDialog from '@/components/ma-device/ma-device-dialog/index.vue'
import MaDianjianDialog from '@/components/ma-dianjian/ma-dianjian-dialog/index.vue'
import MaDeviceType from '@/components/ma-device/ma-device-type/index.vue'
import MaOrgInput from '@/components/ma-org/ma-org-input/index.vue'
import MaRoleInput from '@/components/ma-role-input/index.vue'
import MaPostInput from '@/components/ma-post-input/index.vue'
import MaUploadImage from '@/components/ma-upload/ma-upload-image/index.vue'
import MaUploadImages from '@/components/ma-upload/ma-upload-images/index.vue'
import MaOrgInspectInput from '@/components/ma-org-inspect/ma-org-inspect-input/index.vue'
import MaOrgInspectSelect from '@/components/ma-org-inspect/ma-org-inspect-select/index.vue'
import MaReportInput from '@/components/ma-report/ma-report-input/index.vue'
import MaReportDialog from '@/components/ma-report/ma-report-dialog/index.vue'
import MaInspectDeviceDialog from '@/components/ma-device-inspect/ma-device-dialog/index.vue'
import MaInspectDeviceInput from '@/components/ma-device-inspect/ma-device-input/index.vue'

import searchForm from '@/components/common/searchForm.vue'
import tableCom from '@/components/common/tableCom.vue'
import detailDialog from '@/components/common/detailDialog.vue'
import OnlinePreview from '@/components/common/OnlinePreview.vue'
import AiAssistant from '@/components/AiAssistant/AiAssistant_old.vue'
import PasswordForm from '@/components/PasswordForm/index.vue'
const components = [
	DesignForm,
	GenerateForm,
	MaEditor,
	MaMarkdown,
	MaMarkdownEditor,
	MaMarkdownPreview,
	MaAddress,
	MaIcon,
	MaDictLabel,
	MaDictColumn,
	MaDictColumnList,
	MaDictRadio,
	MaDictSelect,
	MaDictTreeSelect,
	MaDataColumn,
	MaDataLabel,
	MaDataSelect,
	MaDataTreeSelect,
	MaDataTable,
	MaUserInput,
	MaUserDialog,
	MaOrgSelect,
	MaOrgInput,
	MaRoleInput,
	MaPostInput,
	MaUploadImage,
	MaUploadImages,
	MaDeviceInput,
	MaDianjianInput,
	MaDeviceDialog,
	MaDianjianDialog,
	MaDeviceType,
	searchForm,
	tableCom,
	detailDialog,
	OnlinePreview,
	MaOrgInspectInput,
	MaOrgInspectSelect,
	MaInspectDeviceDialog,
	MaInspectDeviceInput,
	zyForm,
	AiAssistant,
	PasswordForm,
	MaReportInput,
	MaReportDialog
]

const MaComponent: Plugin = {
	install(Vue: App) {
		components.forEach((component: any) => {
                        if (component?.name) {
                                Vue.component(component.name, component)
                        }
		})
	}
}

export default MaComponent
